/** CULORILE desenului vectorial pe hârtia platformei: aceleași pentru vizorul
 *  planșelor (`DwgViewer`, canvas) și pentru planșa arhitectului desenată sub
 *  geometria editorului (`PlansaArhitect`, SVG), ca o linie a DWG-ului să aibă
 *  aceeași culoare oriunde o vezi. */

/** cerneala paletei (`--ink`) */
export const INK = "#232323";

const colorCache = new Map<string, string>();
/** Culoarea unei entități pe hârtie deschisă: ACI 7 și culorile aproape albe
 *  se răstoarnă în cerneală, cele deschise se închid păstrând nuanța —
 *  desenele făcute pentru un canvas negru rămân citibile. */
export function displayColor(c: string): string {
  let v = colorCache.get(c);
  if (v) return v;
  v = c;
  if (/^#[0-9a-f]{6}([0-9a-f]{2})?$/i.test(c)) {
    const r = parseInt(c.slice(1, 3), 16);
    const g = parseInt(c.slice(3, 5), 16);
    const b = parseInt(c.slice(5, 7), 16);
    const a = c.slice(7);
    const lum = 0.299 * r + 0.587 * g + 0.114 * b;
    if (lum > 225) v = INK + a;
    else if (lum > 175) {
      // light colors wash out on white — darken while keeping the hue
      const k = 175 / lum;
      v =
        "#" +
        [r, g, b]
          .map((x) => Math.round(x * k).toString(16).padStart(2, "0"))
          .join("") +
        a;
    }
  }
  colorCache.set(c, v);
  return v;
}

const fillCache = new Map<string, string>();
/** Umplerea unei hașuri pline: un negru aproape plin (planșeele ACI 7) ar
 *  acoperi tot planul pe alb — devine un gri străveziu, ca liniile de dedesubt
 *  să se citească. */
export function displayFill(c: string): string {
  let v = fillCache.get(c);
  if (v) return v;
  v = displayColor(c);
  if (/^#[0-9a-f]{6}$/i.test(v)) {
    const r = parseInt(v.slice(1, 3), 16);
    const g = parseInt(v.slice(3, 5), 16);
    const b = parseInt(v.slice(5, 7), 16);
    if (0.299 * r + 0.587 * g + 0.114 * b < 70) v = "rgba(122,122,128,0.28)";
  }
  fillCache.set(c, v);
  return v;
}
